import _Card from './Card';

import './style/index.js';

export * from './type';

export const Card = _Card;

export default Card;
